import React from 'react';


export default function ChartOverLay(){
  return(
    <div className='text-center mt-4 h-auto w-100'><img src="../../static/images/chartOverlay.png" /></div>
  );
}
